module.exports = __webpack_public_path__ + "static/media/MY.8683ca58.png";